import { asyncEmit } from '@/utils/socket';
import type { ResSeeCard, ResHistory } from '@/pages/casino/zhajinhuaGame/ts/types';

export const useGoldenFlower = (rootPath = 'games') => {
    const prefix = `${rootPath}.zhajinhua`;
    const player = `playerEvent`;

    // 查询当前所在房间
    const EMIT_CHECK_PLAYER_TABLEINFO = async (oParams): Promise<any> => {
        const sApi = `${prefix}.checkPlayerTableInfo`;
        const res = await asyncEmit(sApi, oParams);
        return res;
    };

    // 随机加入大厅牌桌
    const EMIT_ZHAJINHUA_JOINTABLE = async (oParams): Promise<any> => {
        const sApi = `${prefix}.joinTable`;
        const res = await asyncEmit(sApi, oParams);
        return res;
    };

    // 加入游戏大厅
    const EMIT_ZHAJINHUA_JOIN = async (oParams): Promise<any> => {
        const sApi = `${prefix}.join`;
        const res = await asyncEmit(sApi, oParams);
        return res;
    };

    // 获取房间最新详情
    const EMIT_ZHAJINHUA_TABLEINFO = async (oParams): Promise<any> => {
        const sApi = `${prefix}.tableInfo`;
        const res = await asyncEmit(sApi, oParams);
        return res;
    };

    // 退出牌桌
    const EMIT_ZHAJINHUA_LEAVE = async (oParams) => {
        const sApi = `${prefix}.leftTable`;
        const res = await asyncEmit(sApi, oParams);
        return res;
    };

    // 强制弃牌并退出当前还在牌桌的牌局
    const EMIT_ZHAJINHUA_FORCE_LEAVE = async (oParams) => {
        const sApi = `${prefix}.forcelefttable`;
        const res = await asyncEmit(sApi, oParams);
        return res;
    };

    // 换桌
    const EMIT_ZHAJINHUA_CHANGETABLE = async (oParams): Promise<any> => {
        const sApi = `${prefix}.changeTable`;
        const res = await asyncEmit(sApi, oParams);
        return res;
    };

    // 取消订阅房间消息
    const EMIT_ZHAJINHUA_EXIT = async (oParams) => {
        const sApi = `${prefix}.exit`;
        const res = await asyncEmit(sApi, oParams);
        return res;
    };

    // 看牌
    const EMIT_ZHAJINHUA_SEE = async (oParams) => {
        const sApi = `${prefix}.see`;
        const res: ResSeeCard = await asyncEmit(sApi, oParams);
        return res;
    };

    // 弃牌
    const EMIT_ZHAJINHUA_FOLD = async (oParams) => {
        const sApi = `${prefix}.fold`;
        const res: ResSeeCard = await asyncEmit(sApi, oParams);
        return res;
    };

    // 跟牌
    const EMIT_ZHAJINHUA_CALL = async (oParams) => {
        const sApi = `${prefix}.call`;
        const res = await asyncEmit(sApi, oParams);
        return res;
    };

    // 全压
    const EMIT_ZHAJINHUA_ALLIN = async (oParams) => {
        const sApi = `${prefix}.allin`;
        const res = await asyncEmit(sApi, oParams);
        return res;
    };

    // 加注
    const EMIT_ZHAJINHUA_RAISE = async (oParams) => {
        const sApi = `${prefix}.raise`;
        const res = await asyncEmit(sApi, oParams);
        return res;
    };

    // 比牌
    const EMIT_ZHAJINHUA_COMPAIRE = async (oParams) => {
        const sApi = `${prefix}.compare`;
        const res = await asyncEmit(sApi, oParams);
        return res;
    };

    // 亮牌
    const EMIT_ZHAJINHUA_SHOWCARD = async (oParams) => {
        const sApi = `${prefix}.showCard`;
        const res = await asyncEmit(sApi, oParams);
        return res;
    };

    // 历史记录
    const EMIT_ZHAJINHUA_HISTORY = async (oParams) => {
        const sApi = `${prefix}.userHistory`;
        const res: ResHistory = await asyncEmit(sApi, oParams);
        return res;
    };

    // 历史记录详情
    const EMIT_ZHAJINHUA_DETAIL = async (oParams, fnCallback) => {
        const sApi = `${prefix}.userHistoryInfo`;
        const res: ResHistory = await asyncEmit(sApi, oParams);
        if (fnCallback) {
            fnCallback(res);
        }
        return res;
    };

    const EMIT_ZHAJINHUA_PLAYCONFIRM = async (oParams) => {
        const sApi = `${prefix}.playConfirm`;
        const res = await asyncEmit(sApi, oParams);
        return res;
    };

    // 玩家进入游戏大厅，带入余额到游戏，锁定资金
    const EMIT_FREEZE = async (oParams) => {
        const sApi = `${prefix}.joinGameFreeze`;
        const res = await asyncEmit(sApi, oParams);
        return res;
    };

    const EMIT_UNFREEZE = async (oParams): Promise<any> => {
        const sApi = `${prefix}.checkAndUnfreeze`;
        const res = await asyncEmit(sApi, oParams);
        return res;
    };

    /*  ----- ↓ 广播事件 ---------------------- */
    const ON_TABLE = (callback: (res) => any) => {
        const sApi = `tableEvent`;
        socket.on(sApi, callback);
        return () => {
            // import.meta.dev && console.log('Channel closed:', sApi);
            socket.off(sApi, callback);
        };
    };
    const ON_PLAYER = (callback: (res) => any) => {
        const sApi = `playerEvent`;
        socket.on(sApi, callback);
        return () => {
            // import.meta.dev && console.log('Channel closed:', sApi);
            socket.off(sApi, callback);
        };
    };
    const ON_NOTICE = (callback: (res) => any) => {
        const sApi = `publicEvent`;
        socket.on(sApi, callback);
        return () => {
            socket.off(sApi, callback);
        };
    };
    const ON_SERVICERESTART =(callback: (res) => any) => {
        const sApi = `serviceRestart`;
        socket.on(sApi, callback);
        return () => {
            socket.off(sApi, callback);
        };
    };
    /*  ----- ↑ 广播事件 ---------------------- */

    return {
        EMIT_CHECK_PLAYER_TABLEINFO,
        EMIT_ZHAJINHUA_JOINTABLE,
        EMIT_ZHAJINHUA_JOIN,
        EMIT_ZHAJINHUA_TABLEINFO,
        EMIT_ZHAJINHUA_SEE,
        EMIT_ZHAJINHUA_FOLD,
        EMIT_ZHAJINHUA_CALL,
        EMIT_ZHAJINHUA_ALLIN,
        EMIT_ZHAJINHUA_RAISE,
        EMIT_ZHAJINHUA_COMPAIRE,
        EMIT_ZHAJINHUA_LEAVE,
        EMIT_ZHAJINHUA_EXIT,
        EMIT_ZHAJINHUA_HISTORY,
        EMIT_ZHAJINHUA_DETAIL,
        EMIT_ZHAJINHUA_SHOWCARD,
        EMIT_ZHAJINHUA_CHANGETABLE,
        EMIT_ZHAJINHUA_FORCE_LEAVE,
        EMIT_ZHAJINHUA_PLAYCONFIRM,
        EMIT_FREEZE,
        EMIT_UNFREEZE,
        ON_TABLE,
        ON_PLAYER,
        ON_NOTICE,
        ON_SERVICERESTART,
    };
};
